// range, mcq, text, number
export const questionTypes = {
  range: "range",
  mcq: "mcq",
  text: "text",
  number: "number",
  checkbox: "checkbox",
  multipleRange: "multiple-range",
};

export const navBarHeight = "72px";

export const navOptionHoverColor = "bg-lightGrey";

// export const navURLLocations = {
//   login: "/login",
//   signUp: "/signup",
//   home: "/",
//   questionaire: "/questionaire",
//   graphs: "/graphs",
//   about: "/about",
// };

export const navURLLocations = {
  dashboard: "/dashboard",
  esgDetails: "/esg-details",
  deiDetails: "/dei-details",
  other: "/other"
};

export const appColors = {
  primaryGreen: "#058E3F",
  primaryGray: "#363536",
  black: "#121212",
  lightGreen: "#81c19c",
  darkGreen: "#006a2d",
  darkWhite: "#ddd",
  inputBackground: "#f6f6f6",
  darkGrey: "#242424",
  grey: "#1c1c1e99",
  secondayGrey: "#6c6c77",
  lightGrey: "#8e8e91",
  primaryRed: "#a63d40",
  secondaryText: "#242424a3",
  primaryYellow: "#eab308",
  secondaryGreen: "#22c55e",
  secondaryRed: "#f43f5e",
  primaryBlue: "#0d6efd",
};

export const sidebarBackgroundColor = "bg-[#5B4DFF]";

export const appPrimaryColor = "bg-darkGrey";

export const phoneNumberRegex = new RegExp(/^[0-9]?(\d{9})$/); // Regex for 9 or 10 digit phone number

// 'pending', 'accepted', 'rejected'
export const farmerInviteStatus = {
  pending: "pending",
  accepted: "accepted",
  rejected: "rejected",
};

export const completeSurveyMessage = "You have completed the survey";

export const inputStyle = 'border border-lightGrey px-4 py-2 border-opacity-40  hover:shadow-md focus:outline-none transition-shadow focus:border-opacity-70 active:border-opacity-70';

export const chartTypes = {
  "pie- chart": "pie-chart",
  "gauge-donut": "gauge-donut",
  'bar-chart': 'bar-chart',
  card: 'card',
};

export const cardTitles = [
  ['Water Conserved', 'gallons'],
  ['Follow Welfare Standards', 'farms'],
  ["Training Sessions Attended", '(average)'],
  ['Total acreage', ''],
]

export const responsiveViewToast = (windowsWidth) => {
  if (windowsWidth < 768) {
    return {
      position: "top-center",
      closeButton: false
    }
  }
  return {}

}

export const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

// Names of all states in the US
export const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' }
];

// Names of all states in the US
export const US_STATES_LIST = [
  { value: 'Alabama', label: 'Alabama', abbreviation: 'AL' },
  { value: 'Alaska', label: 'Alaska', abbreviation: 'AK' },
  { value: 'Arizona', label: 'Arizona', abbreviation: 'AZ' },
  { value: 'Arkansas', label: 'Arkansas', abbreviation: 'AR' },
  { value: 'California', label: 'California', abbreviation: 'CA' },
  { value: 'Colorado', label: 'Colorado', abbreviation: 'CO' },
  { value: 'Connecticut', label: 'Connecticut', abbreviation: 'CT' },
  { value: 'Delaware', label: 'Delaware', abbreviation: 'DE' },
  { value: 'Florida', label: 'Florida', abbreviation: 'FL' },
  { value: 'Georgia', label: 'Georgia', abbreviation: 'GA' },
  { value: 'Hawaii', label: 'Hawaii', abbreviation: 'HI' },
  { value: 'Idaho', label: 'Idaho', abbreviation: 'ID' },
  { value: 'Illinois', label: 'Illinois', abbreviation: 'IL' },
  { value: 'Indiana', label: 'Indiana', abbreviation: 'IN' },
  { value: 'Iowa', label: 'Iowa', abbreviation: 'IA' },
  { value: 'Kansas', label: 'Kansas', abbreviation: 'KS' },
  { value: 'Kentucky', label: 'Kentucky', abbreviation: 'KY' },
  { value: 'Louisiana', label: 'Louisiana', abbreviation: 'LA' },
  { value: 'Maine', label: 'Maine', abbreviation: 'ME' },
  { value: 'Maryland', label: 'Maryland', abbreviation: 'MD' },
  { value: 'Massachusetts', label: 'Massachusetts', abbreviation: 'MA' },
  { value: 'Michigan', label: 'Michigan', abbreviation: 'MI' },
  { value: 'Minnesota', label: 'Minnesota', abbreviation: 'MN' },
  { value: 'Mississippi', label: 'Mississippi', abbreviation: 'MS' },
  { value: 'Missouri', label: 'Missouri', abbreviation: 'MO' },
  { value: 'Montana', label: 'Montana', abbreviation: 'MT' },
  { value: 'Nebraska', label: 'Nebraska', abbreviation: 'NE' },
  { value: 'Nevada', label: 'Nevada', abbreviation: 'NV' },
  { value: 'New Hampshire', label: 'New Hampshire', abbreviation: 'NH' },
  { value: 'New Jersey', label: 'New Jersey', abbreviation: 'NJ' },
  { value: 'New Mexico', label: 'New Mexico', abbreviation: 'NM' },
  { value: 'New York', label: 'New York', abbreviation: 'NY' },
  { value: 'North Carolina', label: 'North Carolina', abbreviation: 'NC' },
  { value: 'North Dakota', label: 'North Dakota', abbreviation: 'ND' },
  { value: 'Ohio', label: 'Ohio', abbreviation: 'OH' },
  { value: 'Oklahoma', label: 'Oklahoma', abbreviation: 'OK' },
  { value: 'Oregon', label: 'Oregon', abbreviation: 'OR' },
  { value: 'Pennsylvania', label: 'Pennsylvania', abbreviation: 'PA' },
  { value: 'Rhode Island', label: 'Rhode Island', abbreviation: 'RI' },
  { value: 'South Carolina', label: 'South Carolina', abbreviation: 'SC' },
  { value: 'South Dakota', label: 'South Dakota', abbreviation: 'SD' },
  { value: 'Tennessee', label: 'Tennessee', abbreviation: 'TN' },
  { value: 'Texas', label: 'Texas', abbreviation: 'TX' },
  { value: 'Utah', label: 'Utah', abbreviation: 'UT' },
  { value: 'Vermont', label: 'Vermont', abbreviation: 'VT' },
  { value: 'Virginia', label: 'Virginia', abbreviation: 'VA' },
  { value: 'Washington', label: 'Washington', abbreviation: 'WA' },
  { value: 'West Virginia', label: 'West Virginia', abbreviation: 'WV' },
  { value: 'Wisconsin', label: 'Wisconsin', abbreviation: 'WI' },
  { value: 'Wyoming', label: 'Wyoming', abbreviation: 'WY' }
];

export const userTypes = [{ "farmer": 'farmer' }, { 'sub-admin': 'sub-admin' }, { 'admin': 'admin' }, { 'super_admin': 'super_admin' }];